import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Badge, Spinner, InputGroup, Nav } from 'react-bootstrap';
import { Search, Send, Paperclip, X, FileText, Image, File, User, Pause, Play, Filter } from 'lucide-react';
import { getConversaciones, getMensajes, enviarMensaje, subirArchivo, checkBotStatus, pauseBot, unpauseBot } from '../../services/inboxService';
import '../../assets/scss/bandeja-mensajes/InboxModerno.scss';
import io from 'socket.io-client';

const InboxModerno = () => {
  const [conversaciones, setConversaciones] = useState([]);
  const [conversacionSeleccionada, setConversacionSeleccionada] = useState(null);
  const [mensajes, setMensajes] = useState([]);
  const [nuevoMensaje, setNuevoMensaje] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [cargandoConversaciones, setCargandoConversaciones] = useState(false);
  const [cargandoMensajes, setCargandoMensajes] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [archivoAdjunto, setArchivoAdjunto] = useState(null);
  const [botPausado, setBotPausado] = useState(false);
  const [filtro, setFiltro] = useState('all'); // all | unread
  const [totalConversaciones, setTotalConversaciones] = useState(0);
  // Estados para paginación de conversaciones
  const [page, setPage] = useState(1);
  const [hasMoreConversaciones, setHasMoreConversaciones] = useState(true);
  const [cargandoMas, setCargandoMas] = useState(false);
  const LIMIT_CONVERSACIONES = 150;
  const mensajesEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const socketRef = useRef(null);
  const conversacionSeleccionadaRef = useRef(null);
  const conversacionesListRef = useRef(null);

  // Mantener la referencia actualizada de la conversación seleccionada
  useEffect(() => {
    conversacionSeleccionadaRef.current = conversacionSeleccionada;
  }, [conversacionSeleccionada]);

  useEffect(() => {

    // Conectar WebSocket
    const userStr = localStorage.getItem('usuario'); // Cambio: 'usuario' en lugar de 'user'


    if (userStr) {
      const user = JSON.parse(userStr);



      const socketUrl = import.meta.env.DEV ? '/' : (import.meta.env.VITE_API_BASE_URL || '/');

      socketRef.current = io(socketUrl, {
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
        path: '/socket.io'
      });

      socketRef.current.on('connect', () => {

        const joinData = {
          userId: user.id.toString(),
          empresaId: user.codigoEmpresa || 91,
        };

        socketRef.current.emit('join', joinData);
      });

      socketRef.current.on('connect_error', (error) => {

      });

      // Escuchar nuevos mensajes
      socketRef.current.on('newMessage', (data) => {


        // Si estoy en la conversación, agregar el mensaje directamente
        const currentConv = conversacionSeleccionadaRef.current;
        if (currentConv && data.leadUuid === currentConv.leadUuid) {

          setMensajes((prev) => {
            // Verificar que el mensaje no exista ya (por ID)
            const existe = prev.find(m => m.tipo === 'mensaje' && m.id === data.mensaje.id);
            if (existe) {

              return prev;
            }

            // Verificar si necesitamos agregar un separador de fecha
            const mensajestemp = [...prev];
            const ultimoItem = mensajestemp[mensajestemp.length - 1];
            const fechaNuevoMensaje = new Date(data.mensaje.fechaCreacion);

            // Si el último item es un mensaje (no una fecha), verificar si es del mismo día
            if (ultimoItem) {
              let fechaUltimoMensaje;
              if (ultimoItem.tipo === 'mensaje') {
                fechaUltimoMensaje = new Date(ultimoItem.fechaCreacion);
              } else if (ultimoItem.tipo === 'fecha') {
                // Si el último es separador de fecha, usar esa fecha
                fechaUltimoMensaje = new Date(ultimoItem.fecha);
              }

              // Comparar si es diferente día
              if (fechaUltimoMensaje) {
                const esMismoDia = fechaNuevoMensaje.toDateString() === fechaUltimoMensaje.toDateString();

                if (!esMismoDia) {
                  // Agregar separador de fecha
                  const hoy = new Date();
                  const ayer = new Date(hoy);
                  ayer.setDate(ayer.getDate() - 1);

                  let etiqueta;
                  if (fechaNuevoMensaje.toDateString() === hoy.toDateString()) {
                    etiqueta = 'Hoy';
                  } else if (fechaNuevoMensaje.toDateString() === ayer.toDateString()) {
                    etiqueta = 'Ayer';
                  } else {
                    etiqueta = fechaNuevoMensaje.toLocaleDateString('es-ES', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric'
                    });
                  }

                  mensajestemp.push({
                    tipo: 'fecha',
                    fecha: data.mensaje.fechaCreacion,
                    etiqueta
                  });
                }
              }
            } else {
              // Si no hay mensajes previos, agregar separador de fecha
              const hoy = new Date();
              const ayer = new Date(hoy);
              ayer.setDate(ayer.getDate() - 1);

              let etiqueta;
              if (fechaNuevoMensaje.toDateString() === hoy.toDateString()) {
                etiqueta = 'Hoy';
              } else if (fechaNuevoMensaje.toDateString() === ayer.toDateString()) {
                etiqueta = 'Ayer';
              } else {
                etiqueta = fechaNuevoMensaje.toLocaleDateString('es-ES', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric'
                });
              }

              mensajestemp.push({
                tipo: 'fecha',
                fecha: data.mensaje.fechaCreacion,
                etiqueta
              });
            }

            // Agregar el mensaje
            mensajestemp.push(data.mensaje);
            return mensajestemp;
          });

          // Marcar como leído inmediatamente via WebSocket
          const userStr2 = localStorage.getItem('usuario');
          const user2 = userStr2 ? JSON.parse(userStr2) : null;
          if (socketRef.current && user2) {
            socketRef.current.emit('markAsRead', {
              leadUuid: data.leadUuid,
              empresaId: user2.codigoEmpresa || 91
            });
          }

          // Scroll suave solo cuando llega un mensaje nuevo en tiempo real
          setTimeout(() => scrollToBottom({ behavior: 'smooth' }), 100);
        } else {

        }

        // Actualización optimista de la lista de conversaciones
        setConversaciones(prev => {
          const index = prev.findIndex(c => c.leadUuid === data.leadUuid);
          if (index === -1) return prev;

          const conv = prev[index];
          const isSelected = conversacionSeleccionadaRef.current?.leadUuid === data.leadUuid;

          const newConv = {
            ...conv,
            ultimoMensaje: data.mensaje,
            ultimaActividad: data.mensaje.fechaCreacion,
            mensajesNoLeidos: isSelected ? 0 : (Number(conv.mensajesNoLeidos || 0) + 1)
          };

          const newConversaciones = [...prev];
          newConversaciones.splice(index, 1);
          newConversaciones.unshift(newConv);
          return newConversaciones;
        });

        cargarConversaciones(true);
      });

      // Escuchar actualizaciones de conversaciones
      socketRef.current.on('conversationsUpdate', () => {

        cargarConversaciones(true);
      });

      socketRef.current.on('disconnect', () => {

      });

      socketRef.current.on('error', (error) => {

      });
    } else {

    }

    return () => {
      if (socketRef.current) {

        socketRef.current.disconnect();
      }
    };
  }, []);

  // Función para hacer scroll
  const scrollToBottom = ({ behavior = 'auto' } = {}) => {
    mensajesEndRef.current?.scrollIntoView({ behavior });
  };

  // Función para hacer scroll a un mensaje específico
  const scrollToMessage = (messageId, { behavior = 'auto' } = {}) => {
    const element = document.getElementById(`mensaje-${messageId}`);
    if (element) {
      element.scrollIntoView({ behavior, block: 'center' });
    }
  };

  // Recargar conversaciones cuando cambia el filtro (inmediato, con spinner)
  useEffect(() => {
    cargarConversaciones(false);
  }, [filtro]);

  // Recargar conversaciones cuando cambia la búsqueda (debounce, silencioso)
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      cargarConversaciones(true);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [busqueda]);

  const cargarConversaciones = async (silencioso = false) => {
    try {
      if (!silencioso) {

        setCargandoConversaciones(true);
      }

      setPage(1); // Reset page on fresh load (always)

      const response = await getConversaciones(1, LIMIT_CONVERSACIONES, filtro, busqueda);
      const nuevasConversaciones = response.data || [];

      // Forzar mensajesNoLeidos=0 para la conversación seleccionada (ya fue leída)
      const selectedUuid = conversacionSeleccionadaRef.current?.leadUuid;
      const convsFinal = selectedUuid
        ? nuevasConversaciones.map(c => c.leadUuid === selectedUuid ? { ...c, mensajesNoLeidos: 0 } : c)
        : nuevasConversaciones;

      setConversaciones(convsFinal);
      setTotalConversaciones(response.meta?.total || 0);
      setHasMoreConversaciones((response.meta?.page || 1) < (response.meta?.totalPages || 1));
    } catch (error) {

    } finally {
      if (!silencioso) {
        setCargandoConversaciones(false);
      }
    }
  };

  // Cargar más conversaciones (paginación infinita)
  const cargarMasConversaciones = async () => {
    if (cargandoMas || !hasMoreConversaciones) return;

    try {
      setCargandoMas(true);
      const nextPage = page + 1;

      const response = await getConversaciones(nextPage, LIMIT_CONVERSACIONES, filtro, busqueda);
      const nuevasConversaciones = response.data || [];

      setConversaciones(prev => [...prev, ...nuevasConversaciones]);
      setPage(nextPage);
      setHasMoreConversaciones(nextPage < (response.meta?.totalPages || 1));

    } catch (error) {

    } finally {
      setCargandoMas(false);
    }
  };

  // Handler para scroll infinito en lista de conversaciones
  const handleScrollConversaciones = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // Si está cerca del final (100px) y hay más conversaciones
    if (scrollHeight - scrollTop - clientHeight < 100 && hasMoreConversaciones && !cargandoMas) {
      cargarMasConversaciones();
    }
  };

  const cargarMensajes = async (leadUuid) => {
    try {
      setCargandoMensajes(true);
      const response = await getMensajes(leadUuid);

      if (conversacionSeleccionadaRef.current?.leadUuid !== leadUuid) {
        return;
      }

      const mensajesData = response.data || [];
      setMensajes(mensajesData);

      setTimeout(() => {
        if (conversacionSeleccionadaRef.current?.leadUuid !== leadUuid) return;

        // Buscar primer no leído (Lead = 1 o Bot = 2)
        const primerNoLeido = mensajesData.find(m => m.leido === 0 && (m.idEmisorTipo === 1 || m.idEmisorTipo === 2));

        if (primerNoLeido) {
          scrollToMessage(primerNoLeido.id, { behavior: 'auto' });
        } else {
          scrollToBottom({ behavior: 'auto' });
        }
      }, 100);

    } catch (error) {
      console.error("Error cargando mensajes", error);
    } finally {
      if (conversacionSeleccionadaRef.current?.leadUuid === leadUuid) {
        setCargandoMensajes(false);
      }
    }
  };

  const seleccionarConversacion = (conversacion) => {
    if (conversacionSeleccionada?.leadUuid === conversacion.leadUuid) return;

    if (conversacionSeleccionada && socketRef.current) {
      socketRef.current.emit('leaveConversation', {
        leadUuid: conversacionSeleccionada.leadUuid
      });
    }

    const convActualizada = { ...conversacion, mensajesNoLeidos: 0 };
    setConversacionSeleccionada(convActualizada);
    conversacionSeleccionadaRef.current = convActualizada;

    // Actualizar la lista de conversaciones para resetear el badge inmediatamente
    setConversaciones(prev => prev.map(c =>
      c.leadUuid === conversacion.leadUuid ? { ...c, mensajesNoLeidos: 0 } : c
    ));

    setMensajes([]);

    cargarMensajes(conversacion.leadUuid);

    checkBotStatus(conversacion.leadUuid).then(status => {
      if (conversacionSeleccionadaRef.current?.leadUuid === conversacion.leadUuid) {
        setBotPausado(status.paused);
      }
    });

    // Unirse a la nueva conversación y marcar mensajes como leídos
    if (socketRef.current) {
      const userStr = localStorage.getItem('usuario');
      const user = userStr ? JSON.parse(userStr) : null;
      const empresaId = user?.codigoEmpresa || 91;

      socketRef.current.emit('joinConversation', {
        leadUuid: conversacion.leadUuid,
        empresaId: empresaId
      });
    }
  };

  const handleEnviarMensaje = async (e) => {
    e.preventDefault();

    if (!nuevoMensaje.trim() && !archivoAdjunto) return;
    if (!conversacionSeleccionada) return;

    const tempId = Date.now();
    const contenidoMsg = nuevoMensaje.trim();
    const isFile = !!archivoAdjunto;
    const fileType = archivoAdjunto?.type || '';
    let tipoMultimedia = null;
    let urlMultimedia = null;
    if (isFile) {
      urlMultimedia = archivoAdjunto.preview;
      if (fileType.startsWith('image')) tipoMultimedia = 'image';
      else if (fileType.startsWith('video')) tipoMultimedia = 'video';
      else if (fileType.startsWith('audio')) tipoMultimedia = 'audio';
      else tipoMultimedia = 'document'; // o 'application'
    }

    const optimisticMsg = {
      id: tempId,
      leadUuid: conversacionSeleccionada.leadUuid,
      contenido: contenidoMsg,
      idEmisorTipo: 3, // Asesor
      fechaCreacion: new Date().toISOString(),
      estadoMensaje: 'pendiente', // Icono reloj
      leido: 1,
      tipo: 'mensaje',
      tipoMultimedia,
      urlMultimedia
    };

    try {
      setEnviando(true);

      setMensajes(prev => {
        const lastItem = prev[prev.length - 1];
        const newMsgDate = new Date();
        const itemsToAdd = [];

        if (lastItem) {
          const lastDate = lastItem.tipo === 'mensaje' ? new Date(lastItem.fechaCreacion) : (lastItem.tipo === 'fecha' ? new Date(lastItem.fecha) : null);
          if (lastDate && lastDate.toDateString() !== newMsgDate.toDateString()) {
            itemsToAdd.push({
              tipo: 'fecha',
              fecha: newMsgDate.toISOString(),
              etiqueta: 'Hoy'
            });
          }
        } else if (prev.length === 0) {
          itemsToAdd.push({
            tipo: 'fecha',
            fecha: newMsgDate.toISOString(),
            etiqueta: 'Hoy'
          });
        }

        itemsToAdd.push(optimisticMsg);
        return [...prev, ...itemsToAdd];
      });

      // Limpiar inputs inmediatamente
      setNuevoMensaje('');
      setArchivoAdjunto(null);
      if (fileInputRef.current) fileInputRef.current.value = '';

      setTimeout(() => scrollToBottom(), 50);

      // Realizar petición API
      let response;
      if (isFile) {
        response = await subirArchivo(
          archivoAdjunto.file,
          conversacionSeleccionada.leadUuid,
          contenidoMsg
        );
      } else {
        const data = {
          leadUuid: conversacionSeleccionada.leadUuid,
          contenido: contenidoMsg
        };
        response = await enviarMensaje(data);
      }

      const realMsg = response.data?.data || response.data || response;

      if (realMsg && realMsg.id) {
        setMensajes(prev => {
          // Si el WebSocket ya lo agregó (por ID real), eliminamos el temporal
          const wsAdded = prev.find(m => m.id === realMsg.id);
          if (wsAdded) {
            return prev.filter(m => m.id !== tempId);
          }
          // Si no, reemplazamos el temporal con el real
          return prev.map(m => m.id === tempId ? { ...realMsg, tipo: 'mensaje' } : m);
        });
      }

    } catch (error) {
      console.error("Error enviando mensaje:", error);
      // Marcar como fallido en la UI
      setMensajes(prev => prev.map(m => m.id === tempId ? { ...m, estadoMensaje: 'fallido' } : m));
    } finally {
      setEnviando(false);
    }
  };

  const handleArchivoSeleccionado = (e) => {
    const file = e.target.files[0];
    if (file) {
      setArchivoAdjunto({
        file,
        name: file.name,
        type: file.type,
        preview: URL.createObjectURL(file)
      });
    }
  };

  const removerArchivo = () => {
    if (archivoAdjunto?.preview) {
      URL.revokeObjectURL(archivoAdjunto.preview);
    }
    setArchivoAdjunto(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleToggleBot = async () => {
    if (!conversacionSeleccionada) return;

    try {
      if (botPausado) {
        await unpauseBot(conversacionSeleccionada.leadUuid);
        setBotPausado(false);
      } else {
        await pauseBot(conversacionSeleccionada.leadUuid);
        setBotPausado(true);
      }
    } catch (error) {

    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    const hoy = new Date();
    const ayer = new Date(hoy);
    ayer.setDate(ayer.getDate() - 1);

    if (date.toDateString() === hoy.toDateString()) {
      return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    } else if (date.toDateString() === ayer.toDateString()) {
      return 'Ayer';
    } else {
      return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' });
    }
  };

  const formatearHora = (fecha) => {
    if (!fecha) return '';
    return new Date(fecha).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  };



  const renderMessageContent = (text) => {
    if (!text) return null;
    const lines = text.split('\n');

    return (
      <div className="mensaje-texto" style={{ width: '100%' }}>
        {lines.map((line, i) => {
          // Detectar items de lista para indentación
          const isListItem = /^[•\-\*]\s/.test(line) || /^\d+\.\s/.test(line);

          return (
            <div
              key={i}
              style={{
                minHeight: line.trim() === '' ? '0.5em' : 'auto',
                marginBottom: '2px', // Espaciado ligero entre líneas como WhatsApp
                paddingLeft: isListItem ? '12px' : '0',
                fontSize: '14.2px',
                lineHeight: '1.4'
              }}
            >
              {parseFormat(line)}
            </div>
          );
        })}
      </div>
    );
  };

  const parseFormat = (text) => {

    const parts = text.split(/(\*[^*]+\*|_[^_]+_|https?:\/\/[^\s]+)/g);

    return parts.map((part, i) => {

      if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
        return <strong key={i}>{part.slice(1, -1)}</strong>;
      }

      if (part.startsWith('_') && part.endsWith('_') && part.length > 2) {
        return <em key={i}>{part.slice(1, -1)}</em>;
      }

      if (part.match(/^https?:\/\//)) {
        return (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#009de2', textDecoration: 'underline' }}
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const renderMultimedia = (mensaje) => {
    if (!mensaje.urlMultimedia) return null;

    // Si es una URL de Google Drive, convertirla a formato embebible
    let urlCompleta = mensaje.urlMultimedia;
    let isGoogleDrive = false;

    if (!mensaje.urlMultimedia.startsWith('http')) {
      const baseUrl = import.meta.env.DEV ? '' : (import.meta.env.VITE_API_BASE_URL || '');
      urlCompleta = `${baseUrl}${mensaje.urlMultimedia}`;
    }
    // Si es Google Drive
    else if (mensaje.urlMultimedia.includes('drive.google.com')) {
      isGoogleDrive = true;
      const match = mensaje.urlMultimedia.match(/\/file\/d\/([^\/]+)/) || mensaje.urlMultimedia.match(/[?&]id=([^&]+)/);
      if (match) {
        urlCompleta = `https://drive.google.com/uc?export=view&id=${match[1]}`;
      }
    }

    switch (mensaje.tipoMultimedia) {
      case 'image':
      case 'imagen':
        // Para Google Drive, mostrar con iframe o link clickeable
        if (isGoogleDrive) {
          return (
            <div className="mensaje-imagen" style={{ cursor: 'pointer', position: 'relative' }}>
              <div
                style={{
                  width: '250px',
                  height: '250px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  background: '#f5f5f5'
                }}
                onClick={() => window.open(urlCompleta, '_blank')}
              >
                <Image size={48} color="#999" />
                <p style={{ margin: '10px 0 0 0', color: '#666', fontSize: '14px' }}>
                  📷 Plano del departamento
                </p>
                <small style={{ color: '#999', fontSize: '12px' }}>Haz clic para ver</small>
              </div>
            </div>
          );
        }

        // Para imágenes locales, mostrar directamente
        return (
          <div className="mensaje-imagen">
            <img
              src={urlCompleta}
              alt="Imagen"
              onError={(e) => {

                e.target.style.display = 'none';
              }}
            />
          </div>
        );
      case 'document':
      case 'documento':
      case 'application':
        return (
          <div className="mensaje-documento p-2 border rounded d-flex align-items-center gap-2" style={{ backgroundColor: '#f8f9fa', minWidth: '200px' }}>
            <FileText size={32} className="text-danger flex-shrink-0" />
            <div className="overflow-hidden flex-grow-1">
              <a href={urlCompleta} target="_blank" rel="noopener noreferrer" className="d-block text-dark text-decoration-none fw-bold text-truncate" style={{ fontSize: '14px' }}>
                {mensaje.contenido || 'Documento adjunto'}
              </a>
              <small className="text-muted d-block" style={{ fontSize: '11px' }}>
                PDF • Clic para ver
              </small>
            </div>
          </div>
        );
      case 'audio':
        return (
          <audio controls src={urlCompleta}>
            Tu navegador no soporta audio
          </audio>
        );
      case 'video':
        return (
          <div className="mensaje-video rounded overflow-hidden bg-black d-flex justify-content-center align-items-center" style={{ maxHeight: '300px', width: '100%', maxWidth: '400px' }}>
            <video
              controls
              src={urlCompleta}
              style={{ maxHeight: '300px', maxWidth: '100%', objectFit: 'contain' }}
            >
              Tu navegador no soporta video
            </video>
          </div>
        );
      default:
        return (
          <div className="mensaje-archivo">
            <File size={24} />
            <a href={urlCompleta} target="_blank" rel="noopener noreferrer">
              Descargar archivo
            </a>
          </div>
        );
    }
  };

  return (
    <Container fluid className="inbox-moderno">
      <Row className="h-100">
        {/* Panel de Conversaciones */}
        <Col md={4} lg={3} className="conversaciones-panel">
          <Card className="h-100 d-flex flex-column">
            <Card.Header className="flex-shrink-0">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mb-0">Conversaciones</h5>
                <Badge bg={filtro === 'unread' ? 'danger' : 'primary'} pill>
                  {totalConversaciones}
                </Badge>
              </div>
              <InputGroup className="mt-2">
                <InputGroup.Text>
                  <Search size={18} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                />
                {busqueda && (
                  <Button variant="outline-secondary" onClick={() => setBusqueda('')}>
                    <X size={18} />
                  </Button>
                )}
              </InputGroup>

              <Nav variant="tabs" className="mt-3 w-100 nav-fill small-tabs" activeKey={filtro} onSelect={(k) => setFiltro(k)}>
                <Nav.Item>
                  <Nav.Link eventKey="all" className="py-2">
                    Todos
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="unread" className="py-2">
                    No leídos
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>
            <Card.Body
              ref={conversacionesListRef}
              className="p-0 flex-grow-1 overflow-auto"
              onScroll={handleScrollConversaciones}
            >
              {cargandoConversaciones ? (
                <div className="text-center p-4">
                  <Spinner animation="border" size="sm" />
                </div>
              ) : (
                <div className="lista-conversaciones">
                  {conversaciones.map((conv) => (
                    <div
                      key={conv.leadUuid}
                      className={`conversacion-item ${conversacionSeleccionada?.leadUuid === conv.leadUuid ? 'activa' : ''
                        }`}
                      onClick={() => seleccionarConversacion(conv)}
                    >
                      <div className="avatar">
                        <User size={24} />
                      </div>
                      <div className="conversacion-info">
                        <div className="conversacion-header">
                          <h6>{conv.numeroTelefono}</h6>
                          <span className="tiempo">
                            {formatearFecha(conv.ultimaActividad)}
                          </span>
                        </div>
                        <div className="conversacion-footer">
                          <p className="ultimo-mensaje">
                            {conv.ultimoMensaje?.tipoMultimedia ? (
                              <span className="multimedia-badge">
                                {conv.ultimoMensaje.tipoMultimedia === 'image' && '📷 Imagen'}
                                {conv.ultimoMensaje.tipoMultimedia === 'document' && '📄 Documento'}
                                {conv.ultimoMensaje.tipoMultimedia === 'audio' && '🎵 Audio'}
                                {conv.ultimoMensaje.tipoMultimedia === 'video' && '🎥 Video'}
                              </span>
                            ) : (
                              conv.ultimoMensaje?.contenido || 'Sin mensajes'
                            )}
                          </p>
                          {conv.mensajesNoLeidos > 0 && conversacionSeleccionada?.leadUuid !== conv.leadUuid && (
                            <Badge bg="primary" pill>
                              {conv.mensajesNoLeidos}
                            </Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* Indicador de carga de más conversaciones */}
                  {cargandoMas && (
                    <div className="text-center p-3">
                      <Spinner animation="border" size="sm" />
                      <small className="ms-2 text-muted">Cargando más...</small>
                    </div>
                  )}
                  {/* Mensaje cuando no hay más */}
                  {!hasMoreConversaciones && conversaciones.length > LIMIT_CONVERSACIONES && (
                    <div className="text-center p-2">
                      <small className="text-muted">No hay más conversaciones</small>
                    </div>
                  )}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Panel de Chat */}
        <Col md={8} lg={9} className="chat-panel">
          {conversacionSeleccionada ? (
            <Card className="h-100 d-flex flex-column">
              <Card.Header>
                <div className="chat-header">
                  <div className="d-flex align-items-center">
                    <div className="avatar me-3">
                      {conversacionSeleccionada.nombreCompleto.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <h5 className="mb-0">{conversacionSeleccionada.nombreCompleto}</h5>
                      <small className="text-muted">
                        {conversacionSeleccionada.numeroTelefono}
                        {conversacionSeleccionada.interesNombre && (
                          <> • {conversacionSeleccionada.interesNombre}</>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Button
                      variant={botPausado ? "warning" : "light"}
                      size="sm"
                      onClick={handleToggleBot}
                      className="d-flex align-items-center gap-2"
                      title={botPausado ? "Reactivar Bot" : "Pausar Bot"}
                    >
                      {botPausado ? <Play size={16} /> : <Pause size={16} />}
                      <span className="d-none d-sm-inline">
                        {botPausado ? "Reactivar Bot" : "Pausar Bot"}
                      </span>
                    </Button>
                    <Badge bg="secondary">{conversacionSeleccionada.estadoGestion}</Badge>
                  </div>
                </div>
              </Card.Header>

              <Card.Body className="chat-body flex-grow-1">
                {cargandoMensajes ? (
                  <div className="text-center p-4">
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <div className="mensajes-container">
                    {mensajes.map((item, index) => {
                      if (item.tipo === 'fecha') {
                        return (
                          <div key={`fecha-${index}`} className="fecha-separador">
                            <span>{item.etiqueta}</span>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            key={item.id}
                            id={`mensaje-${item.id}`} // ID para scroll
                            className={`mensaje ${item.idEmisorTipo === 1 ? 'entrante' : 'saliente'}`}
                          >
                            <div className="mensaje-bubble">
                              {renderMultimedia(item)}
                              {renderMessageContent(item.contenido)}
                              <div className="mensaje-meta">
                                <small className="text-muted">
                                  {formatearHora(item.fechaCreacion)}
                                </small>
                                {item.idEmisorTipo !== 1 && (
                                  <small className="ms-2">
                                    {item.estadoMensaje === 'entregado' && '✓✓'}
                                    {item.estadoMensaje === 'visto' && '✓✓'}
                                    {item.estadoMensaje === 'enviado' && '✓'}
                                  </small>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                    <div ref={mensajesEndRef} />
                  </div>
                )}
              </Card.Body>

              <Card.Footer>
                {archivoAdjunto && (
                  <div className="archivo-preview mb-2">
                    <div className="d-flex align-items-center">
                      {archivoAdjunto.type.startsWith('image/') ? (
                        <Image size={20} className="me-2" />
                      ) : (
                        <File size={20} className="me-2" />
                      )}
                      <span className="flex-grow-1">{archivoAdjunto.name}</span>
                      <Button variant="link" size="sm" onClick={removerArchivo}>
                        <X size={18} />
                      </Button>
                    </div>
                  </div>
                )}

                <Form onSubmit={handleEnviarMensaje}>
                  <InputGroup>
                    <Button
                      variant="outline-secondary"
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <Paperclip size={20} />
                    </Button>
                    <Form.Control
                      placeholder="Escribe un mensaje..."
                      value={nuevoMensaje}
                      onChange={(e) => setNuevoMensaje(e.target.value)}
                      disabled={enviando}
                    />
                    <Button type="submit" disabled={enviando || (!nuevoMensaje.trim() && !archivoAdjunto)}>
                      {enviando ? <Spinner size="sm" /> : <Send size={20} />}
                    </Button>
                  </InputGroup>
                </Form>

                <input
                  ref={fileInputRef}
                  type="file"
                  className="d-none"
                  onChange={handleArchivoSeleccionado}
                  accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
                />
              </Card.Footer>
            </Card>
          ) : (
            <Card className="h-100 d-flex align-items-center justify-content-center">
              <Card.Body className="text-center">
                <h5 className="text-muted">Selecciona una conversación para comenzar</h5>
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default InboxModerno;
